{
  "version": 1,
  "asset_id": "40849755-53cb-4d78-9e77-2733e28d0bcb",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/40849755-53cb-4d78-9e77-2733e28d0bcb/ind-security-automation-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/40849755-53cb-4d78-9e77-2733e28d0bcb/ind-security-automation-1200.webp",
  "original_filename": "ind-security-automation-1200.webp",
  "size": 9582,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:15Z"
}
